import { render } from "./GoToIcon.vue?vue&type=template&id=380bebde&scoped=true"
const script = {}

import "./GoToIcon.vue?vue&type=style&index=0&id=380bebde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380bebde"]])

export default __exports__